import {FilterDefaultType} from '../../types/FilterDefaultType';
import {RootState} from '../rootReducer';

export const getFilterDefaultsFetched = (state: RootState) => state.filterDefaults.fetched;

export const getBundesliga = (state: RootState): FilterDefaultType | null => {
    const result = state.filterDefaults?.data?.result;
    const matchDayItem = result?.find((item: FilterDefaultType) => item.categoryId === 1);
    return matchDayItem ?? null;
};

export const getDefaultSeason = (state: RootState) => {
    return state.filterDefaults.data?.result?.at(0)?.seasonId;
};

const EMPTY_FILTER_DEFAULTS: FilterDefaultType[] = [];

export const getMatchdaysByCategory = (state: RootState): FilterDefaultType[] => {
    return state.filterDefaults?.data?.result ?? EMPTY_FILTER_DEFAULTS;
};
